import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import PropTypes from 'prop-types';
import {Tooltip} from '@material-ui/core';

function InviteButtonView(props) {
  const isOrganisationDeactivated = !props.organisation.enabled;
  const isSubcontractorAndNotDepositor = props.isSubcontractorView && !props.organisation.depositor;
  const disableInviteButton = isOrganisationDeactivated || isSubcontractorAndNotDepositor;

  const button = (
    <span>
      <button
        type="button"
        className="large inline-container primary"
        onClick={props.onClick}
        disabled={disableInviteButton}
      >
        <Icon icon="plus"/>
        <Translate value="user.invite.button"/>
      </button>
    </span>
  );

  const message = (
    (isOrganisationDeactivated && <Translate value="user.invite.orgaDeactivated"/>) ||
    (isSubcontractorAndNotDepositor && <Translate value="user.invite.orgaNonDepositor"/>)
  );

  return (
    disableInviteButton ?
      <Tooltip title={message}>{button}</Tooltip> :
      button
  );
}

InviteButtonView.propTypes = {
  onClick: PropTypes.func.isRequired,
  organisation: PropTypes.object.isRequired,
  isSubcontractorView: PropTypes.bool
};

export default InviteButtonView;
